import React, { useEffect, useState } from 'react'
import Layout from 'Layout'
import { useNavigate, useParams } from 'react-router-dom'
import { message } from 'antd'
import './styles.scss'
import { mixPostV1, mixDayNext, mixGetV1, mixCurrencyFormat, mixGetImage } from 'services/mixin'

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const {slug} = useParams()
  const currentAvtType = localStorage.getItem('setAvt')
  const [detail, setDetail] = useState({})
  const [user, setUser] = useState(null)

  const handleClick = () => {
    navigate("/payment/selected-plan");
  };

  const getGoiDetail = async (slug:any) => {
    try {
      const res = await mixGetV1(`/api/v1/fe/package/${slug}`)

      if(res.status) {
        setDetail(res.data)
      }
    } catch(err) {
      message.error(err?.message || 'Có lỗi xảy ra')
    }
  }
  const getUser = async () => {
    try {
      const res = await mixGetV1('/api/v1/fe/customer/profile')

      if(res.status) {
        setUser(res.data)
      }
    } catch(err) {
      message.error(err?.message || 'Có lỗi xảy ra')
    }
  }

  const handleConfirm = async () => {
    const user = localStorage.getItem('user')

    if (user) {
      const dataHandled = JSON.parse(user)

      const res = await mixPostV1('/api/v1/fe/order/create_v2_test', {
        customer_id: dataHandled.id,
        total: 100,
        package_id: detail.id,
        payment: 3,
        is_subscription: 0,
      })

      if (res.status) {
        const userData = localStorage.getItem('user')
        localStorage.setItem('clientSecret', res.data.response_stripe.client_secret)
        localStorage.setItem('orderId', res.data.id)

        if (userData) {
          navigate(`/payment-by-card`)
        }
      }
    }
  }

  const mixDayNext = (days:number) => {
    // Lấy ngày hiện tại
    const currentDate = new Date()

    // Lấy ngày, tháng, năm hiện tại
    const currentDay = currentDate.getDate()
    const currentMonth = currentDate.getMonth() + 1 // Tháng trong JavaScript bắt đầu từ 0
    const currentYear = currentDate.getFullYear()

    const now = `${currentDay}/${currentMonth}/${currentYear}`

    // Lấy ngày sau số ngày được truyền vào
    const futureDate = new Date()
    futureDate.setDate(currentDate.getDate() + days)

    // Lấy ngày, tháng, năm của ngày sau số ngày đó
    const futureDay = futureDate.getDate()
    const futureMonth = futureDate.getMonth() + 1
    const futureYear = futureDate.getFullYear()
    const next = `${futureDay}/${futureMonth}/${futureYear}`
    return {
      now,
      next,
    }
  }

  const mixCurrencyFormat = (val:any) => {
    return (new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'VND' }).format(val))
  }

  useEffect(()=> {
    getGoiDetail(slug)
  },[slug])
  useEffect(()=> {
    getUser()
  },[])
  // useEffect(()=> {
  //   console.log(user)
  // },[user])

  return (
    <Layout>
      <div className='container flex justify-center flex-col items-center'>
        <div className="title-32-my-65-48">Membership Order</div>
        <div className="sm:w-[555px] sm:px-[40px] px-[16px] sm:py-[32px] w-100 py-[12px] bg-white border border-[#e5e7eb] rounded-md text-[#404654] font-[Inter] text-[14px] leading-[22px]">
          {/* Header */}
          <div className="flex items-center gap-4 mb-5">
            {user?.info.avatar === null || user?.info.avatar === '' || currentAvtType === 'color' ? (
              <div 
                className="w-[64px] h-[64px] rounded-full bg-[#4A587C] flex items-center justify-center text-white text-[24px] font-semibold"
                style={user?.info.avatar_bg ? {backgroundColor: user?.info.avatar_bg} : {backgroundColor: '#4A587C'}}
              >
                <span>{ user?.info.fullname?.charAt(0).toUpperCase() }</span>
              </div>
            ): (
              <div 
                className="w-[64px] h-[64px] rounded-full bg-[#4A587C] flex items-center justify-center text-white text-[24px] font-semibold"
                style={{
                  backgroundImage: `url(${mixGetImage(`/${user?.info.avatar}`)})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat"
                }}
              >
                
              </div>
            )}
            <div>
              <div className="text-[24px] leading-[40px] font-semibold text-[#2E2E2E]">
                {user?.info.fullname}
              </div>
              <div className="text-[#6B7280] leading-[24px] text-[16px]">
                {user?.info.email}
              </div>
            </div>
          </div>

          <hr className="border-[#E5E7EB] mb-6" />

          {/* Plan Info */}
          <div className="mb-6 text-[16px]">
            <div className="flex justify-between mb-[32px]">
              <span>Free Trial Plan</span>
              <span className="font-medium">{detail.name}</span>
            </div>
            <div className="flex justify-between mb-[32px]">
              <span>Plan Duration</span>
              {detail.is_lifetime === 0 ? (
                <span>{detail.day} days</span>
              ): (
                <span>Vô thời hạn</span>
              )}
            </div>
            <div className="flex justify-between mb-[32px]">
              <span>Plan Starts on</span>
              <span>{mixDayNext(detail.day).now}</span>
            </div>
            <div className="flex justify-between mb-[32px]">
              <span>Plan Expires on</span>
              {detail.is_lifetime === 0 ? (
                <span>{mixDayNext(detail.day).next}</span>
              ):(
                <span>Vô thời hạn</span>
              )}
            </div>
          </div>

          {/* Payment Section */}
          <div className="bg-[#F9F8F7] border border-[#E5E7EB] rounded-md p-4 mb-[32px] text-[16px]">
            <div className="flex justify-between items-center mb-[32px]">
              <span className="font-medium">Payment</span>
              <span className="text-[#6B7280] text-[15px] flex items-center">VND
                <div className="icon-svg">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2077_129)">
                      <path d="M7 10L12 15L17 10H7Z" fill="white" />
                      <path d="M7 10L12 15L17 10H7Z" fill="black" fill-opacity="0.35" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2077_129">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </span>
            </div>
            <div className="flex justify-between pr-2 mb-[16px]">
              <span>{detail.day === 30 ? 'Monthly' : 'Yearly'} Rate</span>
              <span>{mixCurrencyFormat(detail.price)}</span>
            </div>
            <hr className="border-[#E5E7EB] mb-[16px]" />
            <div className="flex justify-between pr-2">
              <span>Total Amount</span>
              <span>{mixCurrencyFormat(detail.price)}</span>
            </div>
          </div>

          {/* Confirm Button */}
          <div className="flex justify-end">
            <button className="w-[232px] h-[40px] btn-border-C1A875-cl-C1A875 transition duration-300" onClick={handleConfirm}>
              Confirm
            </button>
          </div>
        </div>

        <div className="mt-[80px] sm:w-[555px] text-[#404654] font-[Inter] text-[16px] leading-[24px] section-all-bank">
          <div className="mb-[32px] text-center flex-wrap">We accept all major payment gateways and support local bank transfers.</div>
          <div className="list-online flex justify-center gap-[36px] mb-[24px] flex-wrap">
            <div className="one-item">
              <img src="/bank/onl1.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/onl2.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/onl3.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/onl4.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/onl5.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/onl6.png" alt="" />
            </div>
          </div>
          <div className="list-online flex justify-center gap-[16px] mb-[48px] flex-wrap">
            <div className="one-item">
              <img src="/bank/bank1.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/bank2.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/bank3.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/bank4.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/bank5.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/bank6.png" alt="" />
            </div>
          </div>
          <div className="flex gap-[8px] justify-center mb-[24px] flex-wrap">
            <span>All payments are processed securely through</span>
            <img width="auto" height="auto" style={{ objectFit: 'contain' }} src="/bank/one-pay.png" alt="" />
          </div>
          <div className="flex gap-[8px] justify-center mb-[24px]">
            <img width="auto" height="auto" style={{ objectFit: 'contain' }} src="/bank/three-image.png" alt="" />
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default Dashboard